import { ParseTranslation } from './translations'

/** Function to declare a new translation, which will be transformed into a type with the respected variables and types */
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/shared/utils/translations/translate.ts", "<global>"],fileName: "/shared/utils/translations/translate.ts",childLine: 4,line: "export function translate<T extends string>(data: T): ParseTranslation<T> {"});
export function translate<T extends string>(data: T): ParseTranslation<T> {
    global.executions.addLine({className: "<global>",functionName: "translate",hierarchy: ["/shared/utils/translations/translate.ts", "<global>", "translate"],fileName: "/shared/utils/translations/translate.ts",childLine: 5,line: "    return {"});
    return {
        translation: data,
        variables: {}
    } as any
}
